import { useMemo, useState } from 'react';
import { SearchComponent } from './SearchComponent';
import type { Connection, ConnectionSearchOptions } from './interfaces';

export const useConnectionSearch = (options?: ConnectionSearchOptions): [Connection, JSX.Element] => {
  const [{ connectionId, connectionType }, setConnectionId] = useState<Connection>({ connectionId: null, connectionType: null });

  const Component = useMemo(() => (
    <SearchComponent
      connectionId={connectionId}
      setConnectionId={setConnectionId}
      {...options || {}}
    />
  ), [connectionId, options]);

  return [{ connectionId, connectionType }, Component];
};
